import { render, staticRenderFns } from "./DocFaceLibraryShow.vue?vue&type=template&id=3b26afcc&scoped=true"
import script from "./DocFaceLibraryShow.vue?vue&type=script&lang=js"
export * from "./DocFaceLibraryShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b26afcc",
  null
  
)

export default component.exports